(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9675],{

/***/ 44045:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-ideas/wash-basin-designs",
      function () {
        return __webpack_require__(62067);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52681);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83346);
/* harmony import */ var _src_components_design_pages_imageList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36774);








const tileData = [
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Black matte countertop wash basin desgin.webp",
        alt: "Black matte countertop wash basin desgin"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Black vanity with wash basin design.webp",
        alt: "Black vanity with wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Brown wash basin design with wooden cabinets.webp",
        alt: "Brown wash basin design with wooden cabinets"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Ceramic wash basin for modern bathroom.webp",
        alt: "Ceramic wash basin for modern bathroom"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Classy wash basin design with artistic mosaic.webp",
        alt: "Classy wash basin design with artistic mosaic"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Classy wash basin design with dual-tone cabinetry.webp",
        alt: "Classy wash basin design with dual-tone cabinetry"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Classy wash basin design with wooden cabinet.webp",
        alt: "Classy wash basin design with wooden cabinet"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Contemporary washbasin design with moroccan tile patterns.webp",
        alt: "Contemporary washbasin design with moroccan tile patterns"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Countertop wash basin design with wooden finish.webp",
        alt: "Countertop wash basin design with wooden finish"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Countertop washbasin with artistic tile accent.webp",
        alt: "Countertop washbasin with artistic tile accent"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Double washbasin desgin for small bathroom.webp",
        alt: "Double washbasin desgin for small bathroom"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Double wash basin design pair,wooden cabinetry.webp",
        alt: "Double wash basin design pair,wooden cabinetry"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Double washbasin design with green floral tiles.webp",
        alt: "Double washbasin design with green floral tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Double wash basin design with storage compartments.webp",
        alt: "Double wash basin design with storage compartments"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Dual wash basin design setup for bathroom.webp",
        alt: "Dual wash basin design setup for bathroom"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Dual wash basins and stylish tiles.webp",
        alt: "Dual wash basins and stylish tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Elegant Bathroom with sleek wah basin design and  Floating Marble Vanity.webp",
        alt: "Elegant Bathroom with sleek wah basin design and  Floating Marble Vanity"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Exotic tile pattern for sleek wash basin design.webp",
        alt: "Exotic tile pattern for sleek wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Floating vanity with modern wash basin design.webp",
        alt: "Floating vanity with modern wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Floating washbasin design with brown tiles.webp",
        alt: "Floating washbasin design with brown tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Floating wash basin design with round mirror.webp",
        alt: "Floating wash basin design with round mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Floral tile with a sleek wash basin design.webp",
        alt: "Floral tile with a sleek wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Geometric patterned tiles with wash basin design.webp",
        alt: "Geometric patterned tiles with wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Geometric patterns for sleek wash basin design.webp",
        alt: "Geometric patterns for sleek wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Gray stone wash basin design with natural wood finish.webp",
        alt: "Gray stone wash basin design with natural wood finish"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Luxurious bathroom with vessel wash basin design.webp",
        alt: "Luxurious bathroom with vessel wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Luxurious washbasin design and beige tiles.webp",
        alt: "Luxurious washbasin design and beige tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Minimalist washbasin design with black countertop.webp",
        alt: "Minimalist washbasin design with black countertop"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Minimalist wash basin design with warm flooring.webp",
        alt: "Minimalist wash basin design with warm flooring"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Modern dual wash basin design.webp",
        alt: "Modern dual wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Modern washbasin design and decorative tiles.webp",
        alt: "Modern washbasin design and decorative tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Modern wash basin design paired with mirror.webp",
        alt: "Modern wash basin design paired with mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Modern wash basin design with soft lighting.webp",
        alt: "Modern wash basin design with soft lighting"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Natural stone wash basin design.webp",
        alt: "Natural stone wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Oval washbasin design paired with a large mirror.webp",
        alt: "Oval washbasin design paired with a large mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Ova shaped wash basin design.webp",
        alt: "Ova shaped wash basin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Pedestal washbasin design with floral accent wall.webp",
        alt: "Pedestal washbasin design with floral accent wall"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Rectangular wash basin paired with mirror.webp",
        alt: "Rectangular wash basin paired with mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/SBG White Herringbone.webp",
        alt: "SBG White Herringbone"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Sleek washbasin design paired with beige tiles.webp",
        alt: "Sleek washbasin design paired with beige tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Sleek washbasin design with highlight pattern.webp",
        alt: "Sleek washbasin design with highlight pattern"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Sleek washbasin design with modern faucets.webp",
        alt: "Sleek washbasin design with modern faucets"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Sleek washbasin design with neutral tones.webp",
        alt: "Sleek washbasin design with neutral tones"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Sleek wash basin design with wooden storage.webp",
        alt: "Sleek wash basin design with wooden storage"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Small bathroom featuring a chic washbasin design.webp",
        alt: "Small bathroom featuring a chic washbasin design"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Stone wash basin design with rustic touch.webp",
        alt: "Stone wash basin design with rustic touch"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Stylish washbasin design with a gray circular sink.webp",
        alt: "Stylish washbasin design with a gray circular sink"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Stylish wash basin design with marble textures.webp",
        alt: "Stylish wash basin design with marble textures"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Stylish wash basin design with plain mosaic tiles.webp",
        alt: "Stylish wash basin design with plain mosaic tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Trendy washbasin design with wooden vanity.webp",
        alt: "Trendy washbasin design with wooden vanity"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Vessel wash basin design with Floating vanity.webp",
        alt: "Vessel wash basin design with Floating vanity"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wall mounted wash basin design with neutral tone.webp",
        alt: "Wall mounted wash basin design with neutral tone"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design for modern bathroom.webp",
        alt: "Wash basin design for modern bathroom"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design paired with blue trapezoid tiles.webp",
        alt: "Washbasin design paired with blue trapezoid tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design paired with dark wooden.webp",
        alt: "Wash basin design paired with dark wooden"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design paired with marble-look tiles.webp",
        alt: "Washbasin design paired with marble-look tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design pair with wooden shelf.webp",
        alt: "Wash basin design pair with wooden shelf"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with a oval-shaped mirror.webp",
        alt: "Washbasin design with a oval-shaped mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with beige or brown tiles.webp",
        alt: "Wash basin design with beige or brown tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with black and white tiles.webp",
        alt: "Washbasin design with black and white tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with black metal frame.webp",
        alt: "Washbasin design with black metal frame"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with blue and white pattern tiles.webp",
        alt: "Wash basin design with blue and white pattern tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with circular mirror.webp",
        alt: "Wash basin design with circular mirror"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with dark green accent.webp",
        alt: "Wash basin design with dark green accent"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with dark marble tiles.webp",
        alt: "Wash basin design with dark marble tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with double vanity setup.webp",
        alt: "Wash basin design with double vanity setup"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with floating wooden vanity.webp",
        alt: "Washbasin design with floating wooden vanity"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with floral green pattern.webp",
        alt: "Wash basin design with floral green pattern"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with floral highlighter tiles.webp",
        alt: "Washbasin design with floral highlighter tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with floral-patterned tiles.webp",
        alt: "Wash basin design with floral-patterned tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with flowery leaf patterns.webp",
        alt: "Wash basin design with flowery leaf patterns"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with geometric tiles.webp",
        alt: "Wash basin design with geometric tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with geometric wall tile.webp",
        alt: "Wash basin design with geometric wall tile"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with golden veined black tiles.webp",
        alt: "Washbasin design with golden veined black tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with green and white striped tile.webp",
        alt: "Washbasin design with green and white striped tile"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with grey ceramic tiles.webp",
        alt: "Washbasin design with grey ceramic tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/wash basin design with marble countertop.webp",
        alt: "wash basin design with marble countertop"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/washbasin design with marble inspired look.webp",
        alt: "washbasin design with marble inspired look"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with matte brown cabinate.webp",
        alt: "Washbasin design with matte brown cabinate"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with moorish patterned tiles.webp",
        alt: "Washbasin design with moorish patterned tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with multi floral pattern tiles.webp",
        alt: "Wash basin design with multi floral pattern tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with natural accent wall.webp",
        alt: "Wash basin design with natural accent wall"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with patterned brown tiles.webp",
        alt: "Washbasin design with patterned brown tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with plumbing fixtures.webp",
        alt: "Wash basin design with plumbing fixtures"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with popsicle patterned tiles.webp",
        alt: "Washbasin design with popsicle patterned tiles"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with porcelain sinks.webp",
        alt: "Washbasin design with porcelain sinks"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with scenic window view.webp",
        alt: "Washbasin design with scenic window view"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with seamless cabinetry.webp",
        alt: "Wash basin design with seamless cabinetry"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with skeleton leaf tile.webp",
        alt: "Washbasin design with skeleton leaf tile"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with sleek chrome faucets.webp",
        alt: "Wash basin design with sleek chrome faucets"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin design with white marble countertop.webp",
        alt: "Washbasin design with white marble countertop"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with wooden cabinetry.webp",
        alt: "Wash basin design with wooden cabinetry"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basin design with wooden look flooring.webp",
        alt: "Wash basin design with wooden look flooring"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin featuring with grey stone texture.webp",
        alt: "Washbasin featuring with grey stone texture"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Wash basins design with floating beige countertop.webp",
        alt: "Wash basins design with floating beige countertop"
    },
    {
        src: "https://images.orientbell.com/media/design-images/Wash-Basin/Washbasin Setup with light and dark grey tones.webp",
        alt: "Washbasin Setup with light and dark grey tones"
    }
];
const faqs = [
    {
        question: "What should be the right size of a wash basin?",
        answer: "The size of your wash basin will depend on the available space and usage. However, the standard size ranges from 20 to 30 inches in diameter. You have to consider the layout of the room and the space available to determine the right size."
    },
    {
        question: "Which wash basin design is better?",
        answer: "The best wash basin design depends on your preferences and the room’s function. For a modern appearance, you can choose a pedestal or wall-mounted design that offers a sleek, space-saving option. But, if luxury is what you are looking for, go for vanity or countertop basins made from materials like marble or granite."
    },
    {
        question: "Which material is best for wash basin design, ceramic or porcelain?",
        answer: "Both ceramic and porcelain can be great choices for a wash basin. Ceramic wash basin designs are versatile; they come in numerous design options and are affordable. Whereas porcelain is durable and premium-looking. Both options work best for bathroom and kitchen areas."
    },
    {
        question: "Can mosaic tiles be used for my wash basin?",
        answer: "Yes, mosaic tiles are perfect for creating unique and vibrant wash basin designs. They work beautifully as backsplashes or accents, adding texture and colour to your setup."
    },
    {
        question: "How do I maintain wash basin tiles?",
        answer: "Regular cleaning with mild detergents and a soft cloth keeps wash basin tiles looking new. Avoid abrasive cleaners to preserve their finish and ensure long-lasting beauty. "
    },
    {
        question: "Which tile material is the most durable?",
        answer: "Ceramic tiles are among the most durable options for wash basins. They are known to resist moisture and daily wear, making them a practical and stylish choice."
    }
];
const text = " The wash basin has​​ a unique charm. It effortlessly blends utility with design to create a focal point in any setting. The choice of wash basin tiles plays an important role. These tiles bring a perfect balance of style and functionality, enhancing the overall look of your space. With various designs, colours, and textures, wash basin tile ideas offer endless possibilities for any renovation or remodel. Whether aiming for a bold statement or a subtle finish, these tiles ensure your choice reflects your personality while adding character and durability to your surroundings.";
const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 3
            }
        },
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 2
            }
        },
        {
            breakpoint: 641,
            settings: {
                arrows: true,
                centerMode: false,
                slidesToShow: 1
            }
        }
    ]
};
function WashBasinTilesDesign() {
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const [isExpertTalkClicked, setIsExpertTalkClicked] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null);
    const [relatedBlogData, setRelatedBlogData] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    const [isReadMore, setIsReadMore] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    const [showAll, setShowAll] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        getRelatedBlogs();
    }, []);
    const toggleReadMore = ()=>{
        setIsReadMore(!isReadMore);
    };
    var requestOptions = {
        method: "GET"
    };
    const getRelatedBlogs = async ()=>{
        // try{
        fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/blog/wp-json/post/v2/category/term=bathroom-designs"), requestOptions).then((response)=>response.text()).then((result)=>{
            setRelatedBlogData(JSON.parse(result));
        }).catch((error)=>console.log("error", error));
    };
    const handleToggle = (index)=>{
        setActiveIndex(activeIndex === index ? null : index);
    };
    const maxChars = 300;
    const previewText = text.substring(0, maxChars);
    const remainingText = text.substring(maxChars);
    const displayedFAQs = showAll ? faqs : faqs.slice(0, 5);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "90+ Beautiful Wash Basin Tiles Design For Your Home | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "90+ Beautiful Wash Basin Tiles Design For Your Home | Orientbell"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Explore over 90 stunning wash basin tiles design to elevate your home's aesthetics. Explore stylish, modern, and functional wash basin tile ideas at Orientbell."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "designpage-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                    href: "/",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                    href: "/design-ideas",
                                    children: "Design Ideas"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                    href: "/design-ideas/wash-basin-designs",
                                    children: "Wash Basin"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "designpage-heading-bx padding-spacing",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                    children: [
                                        "Showing ",
                                        tileData.length,
                                        " results for "
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: "Wash Basin Design Ideas"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "description-text",
                                    children: [
                                        previewText,
                                        !isReadMore && text.length > maxChars && "...",
                                        isReadMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: remainingText
                                        }),
                                        text.length > maxChars && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: toggleReadMore,
                                            children: isReadMore ? "Read Less" : "Read More"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "obl-master-design-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: "Wash Basin Design Gallery"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "designpage-category-row inner-design-gallery",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_design_pages_imageList__WEBPACK_IMPORTED_MODULE_6__/* .ImageList */ .Y, {
                                        tileData: tileData
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "bottom-content",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: " Wash Basin Design Ideas"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "There are various wash basin designs to cater to different tastes and requirements. Here are some popular styles of wash basins that combine aesthetic appeal with functionality, making them perfect for modern homes."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Pedestal Wash Basin Design"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "The pedestal wash basin is the most traditional of choices, having a freestanding form that hides the plumbing but is full of style and elegance in its design elements. The pedestal is commonly made of the same material as the basin to have a cohesive appearance. These wash basin designs require minimal maintenance and work well in a more traditional or transitional setting."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Vanity Wash Basin Designs"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Vanity basins with inbuilt cabinets are perfect for bathrooms that require storage. The designs maximise space optimisation and give a lavish look. Combining these basin designs with wooden backsplash tiles can make the space feel warm and welcoming. You could further add metallic or matte-finish handles to give a sophisticated edge to these designs."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Corner Wash Basin Design"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Designed to optimise space, corner wash basins are a smart solution for small rooms. It can perfectly fit in an unused corner of the room and leave the rest of the area free for movement. They are ideal for cramped spaces as they allow for the better use of available areas while offering functionality. They are also ideal for guest bathrooms or compact kitchens."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Square Wash Basin Designs"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Square basins are trendy and sleek, offering a minimalist yet bold look. The angular shape brings structure and symmetry to modern homes. They are good for contemporary settings, especially if used with geometric-patterned tiles or monochrome schemes for a cohesive aesthetic appeal."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Standing Wash Basin Design"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Standing wash basins are versatile and easy to install. Their freestanding design allows for flexibility in placement, giving you the freedom to position them wherever they best fit. They are available in a wide range of materials, including ceramic, stone, and even modern concrete. This design is particularly popular in contemporary bathrooms and kitchen spaces."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Table Top Wash Basin Designs"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Placed above the counter, they create a stunning visual impact and become the centrepiece of the room. Available in various materials like ceramic, glass, stone, or even concrete, these basins offer a lot of design elements and finish versatility. The sleek, elevated design allows for easy cleaning and maintenance while offering ample space optimisation for storage underneath."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "Bathroom Wash Basin Designs"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Thoughtful wash basin design in a bathroom is a crucial component that is a perfect blend of luxury and practicality. Modern wash basin bathroom design can easily fit compact bathrooms as well as spacious ones. They also enhance the overall aesthetic of your space while promoting personal hygiene."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Wall-Mounted Wash Basins "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "These basins work wonders for small-size bathrooms as they save floor space while having a minimalist look. You can pair a white ceramic wall-mounted basin with textured tiles in earthy tones to create a clean and modern look. These basin designs are perfect for contemporary and minimalist homes that have simple furniture and decor."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Countertop Wash Basins"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "The countertop wash basin design could be a luxurious addition, often serving as the focal point of your bathroom. These basins, especially in stone or ceramic finishes, can be paired with wooden cabinetry and warm lighting to bring in a spa-like ambience. This design adds a sense of luxury and elegance, perfect for creating a serene atmosphere in modern bathrooms."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Pedestal Wash Basins"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Timeless and practical, pedestal basins go well with bathrooms that have a classic or vintage theme. A marble pedestal basin paired with patterned tiles can elevate the space, adding a refined elegance to traditional designs. This style is perfect for those who love renovation ideas that blend vintage charm with modern functionality."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Double Wash Basins "
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Double basins are a practical and stylish choice for bathrooms. Installed on a sleek vanity unit with mirrored cabinets, a double basin can enhance the overall ambience. This design is ideal for larger bathrooms; they promote space management and allow multiple people to use the basin conveniently."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "Kitchen Wash Basin Designs"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "In the kitchen, a wash basin design could be a functional centrepiece that complements the overall kitchen layout and design aesthetics. This makes it important to choose the right basin to ensure durability and looks."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Stainless Steel Sinks"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Stainless steel sinks are most common in kitchens because of their durability and low maintenance. The non-porous surface of this material helps resist bacteria buildup. This makes it hygienic and aids in food preparation and washing dishes. You can go ahead with a double-bowl stainless steel sink with white subway tiles to create a contemporary look while making it suitable for busy kitchens."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Undermount Basins"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Undermount wash basin designs for the kitchen are ideal\n                      for a modern layout due to their seamless design. This\n                      design eliminates the need for a rim, providing a smooth\n                      and uninterrupted surface. As a result, it's much easier\n                      to wipe down countertops without debris getting caught,\n                      making cleaning hassle-free. When paired with a granite\n                      countertop, these basins create a sleek and durable\n                      finish, perfect for daily practical use."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Corner Sinks"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "For compact kitchens, corner sinks make excellent use of unused space. You can install a corner sink paired with minimalist cabinets to make the most of the layout. This type of sink is perfect for kitchens with limited space, offering a practical and space-saving option without compromising on the style."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Farmhouse Sinks"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Farmhouse sinks are known to bring that age-old rustic charm to the kitchen. With their rectangular shape with a deep, spacious basin design, they provide ample space for washing large pots, pans, and dishes. Also, their open shape allows for easy cleaning and requires minimal maintenance. A white ceramic farmhouse sink combined with wooden cabinets creates a cosy and traditional vibe, blending functionality with timeless style."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Double Wash Basins"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Double-wash basin designs for the kitchen are an excellent choice if you have a larger kitchen space. These basins, especially in stainless steel, provide separate sections for washing and rinsing. You can pair these with a tiled backsplash in bold geometric patterns, ensuring a seamless blend of practicality and style."
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "Wash Basin Designs for Dining Room"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "A well-planned dining wash basin design ensures that functionality is not compromised and the aesthetic is maintained. This contributes to dining space elegance and decor harmony."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Wall-Mounted Basins with Mirrors"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Modern wash basin designs in the hall often feature wall-mounted basins that save space and add a modern touch. You can get a rectangular basin complemented by a large mirror with a gold frame to create a luxurious look. It will also make it a statement piece in the dining space. These basin designs also take care of hygiene while maintaining space efficiency."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Compact Corner Basins"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Dining wash basin designs like corner basins are perfect for small dining areas. These designs help to maximise space while keeping the dining area neat. This contributes to seamless integration into the overall dining space."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Freestanding Basins"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "The freestanding dining hall wash basin design brings a bold and elegant statement to dining spaces. A marble freestanding basin with ambient lighting enhances sophistication, making it a standout feature in modern dining rooms. Its unique design adds a touch of opulence and can serve as a focal point in the dining area, creating decor harmony."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Wooden Cabinet Basins"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "These basins are a harmonious blend of storage and style, ideal for dining spaces with a warm and cosy vibe. A wooden cabinet basin with a brass faucet adds functionality while ensuring seamless decor integration. The storage space beneath the basin helps keep the dining area organised, enhancing hygiene and space efficiency."
                                                                }),
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "How to Choose the Right Basin Tiles?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "Selecting the perfect tiles for a wash basin wall can elevate the aesthetics of your space while ensuring functionality. Here are some tips you can consider:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Understand the Role of Tiles"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Tiles play an important role in defining the all-around look of your basin area. They provide a protective background against moisture while enhancing the visual appeal with their texture and style."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Consider the Basin’s Size"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Getting tiles to match the size of your wash basin area is key. For smaller spaces, opt for lighter shades that create an open and airy feel. In larger areas, bold tiles with intricate patterns can add a dramatic touch. The right tile design ensures a balanced and harmonious look."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Focus on the Design Theme"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Get a wash basin wall tile design that will complement the design theme of your basin space. For a modern vibe, opt for sleek, minimalist tiles, while vintage or rustic spaces benefit from textured or patterned tiles."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Play with Shapes and Patterns"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Incorporate unique shapes and patterns to add character. Hexagonal tiles, mosaic patterns, or subway tiles can create an eye-catching background. These designs offer a balance of style and usability."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Prioritise Durability and Care"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Ensure your tiles can resist moisture and are easy to maintain. Wash basin background tile design ideas should focus on long-lasting usability that retains its beauty over time."
                                                                }),
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "common-text-content-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    children: "Why Choose Orientbell?"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: "In a legacy spanning over four decades, Orientbell Tiles has transformed the tile industry. With innovative solutions tailored to every need, we ensure that your washbasin area is functional and stylish."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Extensive Design Collection"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Orientbell Tiles offers a wide range of washbasin wall tile design options that cater to every taste. Whether you have marble wash basin designs or robust granite wash basin designs, our tile collection can complement it all. We feature stunning backsplash tiles that protect walls while adding a decorative touch. Additionally, our durable countertop tiles are designed to elevate your wash basin setup."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Consider the Basin’s Size"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Getting tiles to match the size of your wash basin area is key. For smaller spaces, opt for lighter shades that create an open and airy feel. In larger areas, bold tiles with intricate patterns can add a dramatic touch. The right tile design ensures a balanced and harmonious look."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: " Versatile Styles and Designs"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "The versatility of Orientbell’s tiles ensures that you’ll find the perfect match for your wash basin. Our tiles are crafted with unique patterns, offering styles that range from modern to warm and rustic. These options bring a refined touch to any space, making your wash basin a standout feature."
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Sizes for Every Layout"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Orientbell Tiles offers a thoughtfully curated range of sizes to cater to various wash basin layouts. Whether you prefer a bold statement or a compact, neat design, our tiles fit every need. The available options include large format tiles to regular ones, perfect for creating your desired looks. Additionally, small tiles are ideal for intricate designs, giving you the freedom to customise your wash basin area effortlessly."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Durable and Low-maintenance"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Orientbell Tiles are made with high-quality ceramic and vitrified materials, ensuring long-lasting performance. These tiles are not only beautiful but also easy to maintain. This makes them an ideal choice for busy households or commercial setups."
                                                                }),
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                                                        children: "Visualise Before You Buy"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    children: "Orientbell Tile’s TriaLook Tile Visualiser takes the guesswork out of choosing tiles. This innovative tool allows you to preview how different wash basin background tile design ideas will look in your space, helping you make confident decisions. Whether you’re exploring textures, designs or colour schemes, TriaLook ensures a smooth selection process."
                                                                }),
                                                                " "
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "designpage-faq-section padding-spacing",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "FAQs About Wash Basin Design"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "newacd designpage-faq-row",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: "accordion",
                                                    children: displayedFAQs.map((faq, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                    className: "toggle",
                                                                    onClick: ()=>handleToggle(index),
                                                                    children: [
                                                                        index + 1,
                                                                        ". ",
                                                                        faq.question
                                                                    ]
                                                                }),
                                                                activeIndex === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                    className: "inner",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: faq.answer
                                                                    })
                                                                })
                                                            ]
                                                        }, index))
                                                }),
                                                faqs.length > 5 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "tru_btn_new design-page",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        className: "btn btn-primary",
                                                        onClick: ()=>setShowAll(!showAll),
                                                        children: showAll ? "Show Less" : "Read More"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "tile-related-blog",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            className: "title",
                                            children: "Related Blogs"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "designpage-relatedpost-row",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                ...settings,
                                                children: relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.map((obj, index)=>{
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "related-blog-col",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "blog-figure",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: obj.permalink,
                                                                    rel: "nofollow",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: obj.image,
                                                                        loading: "lazy",
                                                                        alt: "Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "blog-text",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingDate",
                                                                        children: obj.date
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingHead",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            rel: "nofollow",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.title
                                                                                }
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "listingText",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                children: [
                                                                                    " ",
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        dangerouslySetInnerHTML: {
                                                                                            __html: obj.content.slice(0, -11)
                                                                                        }
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "listingButton",
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                    href: obj.permalink,
                                                                                    rel: "nofollow",
                                                                                    children: "Read More"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (WashBasinTilesDesign);


/***/ }),

/***/ 36774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ ImageList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);
/* harmony import */ var _api_services_js_others__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63372);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4492);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35005);





const ImageList = (param)=>{
    let { tileData  } = param;
    const [isExpertTalkClicked, setIsExpertTalkClicked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [showAllTiles, setShowAllTiles] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [displayedTileData, setDisplayedTileData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(tileData.slice(0, 6));
    const [touch, setTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("pincode"),
        error: "",
        loading: false
    });
    const submitGetInTouch = async ()=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        if (!namee || !no || !pin) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (String(pin).length != 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            let response = await (0,_api_services_js_others__WEBPACK_IMPORTED_MODULE_3__/* .getIntouch */ .JJ)({
                name: namee,
                phone: no,
                pincode: pin
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                swal(response === null || response === void 0 ? void 0 : response.message);
                setTouch({
                    ...touch,
                    error: "",
                    loading: false
                });
            } else {
                swal(response.data.get_in_touch.msg);
                // setGetInTouch(false)
                setTouch({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
                setIsExpertTalkClicked(false);
            }
        }
    };
    const handleViewMore = ()=>{
        if (!showAllTiles) setDisplayedTileData((prev)=>[
                ...prev,
                ...tileData.slice(prev.length, prev.length + 6)
            ]);
        if (showAllTiles) setDisplayedTileData(tileData.slice(0, 6));
        if (displayedTileData.length + 6 >= tileData.length) setShowAllTiles(!showAllTiles);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "designpage-category-row inner-design-gallery",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "designpage-category-row inner-design-gallery",
                children: displayedTileData.map((tile, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "designpage-category-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "designpage-figure",
                                children: tile.src ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    ...tile,
                                    loading: "lazy"
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: tile.image,
                                    alt: tile.alt,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "designpage-text",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "talk-expert-btn talk-to-expert-design-page",
                                    onClick: ()=>setIsExpertTalkClicked(true),
                                    children: "Talk to Expert"
                                })
                            })
                        ]
                    }, index))
            }),
            tileData.length > 6 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "tru_btn_new design-page",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn btn-primary",
                    onClick: handleViewMore,
                    children: showAllTiles ? "View Less" : "View More"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                show: isExpertTalkClicked,
                className: "pincode-popup-bx expert_assistance_modal ask-question-popup",
                onHide: ()=>{
                    // setTimePopup(false)
                    // setGetInTouch(false)
                    setIsExpertTalkClicked(false);
                // localStorage.setItem('leadSkiped',true)
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Dialog */ .Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Header */ .Z.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Title */ .Z.Title, {
                                children: "Get in touch with our tile expert"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ask-question-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "expert-fig-bx",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/new-tareek.jpg"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Body */ .Z.Body, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "Ask Tile Expert"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Let Experts Help You In Buying Process"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            onSubmit: (e)=>{
                                                e.preventDefault();
                                                submitGetInTouch();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicEmail",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "text",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    name: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Mobile"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    number: "".concat(touch.countryCode || "").concat(e.target.value)
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Label */ .Z.Label, {
                                                            children: "Pincode"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            value: touch.pincode,
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    pincode: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "error text-danger",
                                                    children: touch.error
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                    variant: "primary",
                                                    type: "submit",
                                                    disabled: touch.loading,
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: touch.loading ? "Submitting" : "Submit"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 52681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15094);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Breadcrumb = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ol", {
      ...listProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Breadcrumb, {
  Item: _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
}));

/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BreadcrumbItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7361,7767,5518,4585,7615,6212,2770,3372,9774,2888,179], function() { return __webpack_exec__(44045); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);